import * as types from '../actions/actionTypes';
import { asyncActionCreator } from './asyncActionCreatorFactory';
import serverApi from '../serverApi';

export const setCloneSourceImage = (imageId) => {
	return { type: types.CLONE_SOURCE_SELECTED, imageId: imageId };
};

export const setCloneDestination = (destinationLocation) => {
	return { type: types.CLONE_DESTINATION_SELECTED, destinationLocation };
};

export const startCloningOperation = (cloneDetails) => {
	return asyncActionCreator(types.CLONE_CREATION_UPDATED, 
		serverApi.startCreateCloneOperation(cloneDetails), 
		json => {
			return { cloneId: json.cloneId, clone: json.clone };
		});
};


// WEBPACK FOOTER //
// ./src/js/actions/cloningWorkflowActionCreators.js